<section class="profile">

  <div class="profile-banner pb-3">
    <img src="../../assets/brand/profile_banner.png" class="img-fluid banner-opacity" alt="profile-banner">
    <div class="centered h1 text-gold">Profile</div>
  </div>

  <div class="overlap-top container my-sm-5 mt-md-0">
    <div class="row">
      <div class="col-lg-8 mb-md-5">
        <div class="row">

          <div class="col-12 bg-white-opac shadow py-3 mb-5">
            <h6 class="text-uppercase mb-md-4">MY INFORMATION</h6>

            <form [formGroup]="userForm" (ngSubmit)="onUpdate(userForm)" class="row row-form g-3 opacity font-mulish">
              <span class="text-uppercase pt-3">User Information</span>

              <div class="col-md-6 mt-2 px-4">
                <label for="validationFirstName" class="form-label">First name</label>
                <input type="text" class="form-control" id="validationFirstName" formControlName="first_name" value="">
                <div class="invalid-feedback d-block"
                    *ngIf="f['first_name'].errors?.['required'] && (f['first_name'].dirty || f['first_name'].touched)">
                    Please fill first name.
                </div>
              </div>
              <div class="col-md-6 mt-2 px-4">
                <label for="validationLastName" class="form-label">Last name</label>
                <input type="text" class="form-control" id="validationLastName" formControlName="last_name" value="">
                <div class="invalid-feedback d-block"
                    *ngIf="f['last_name'].errors?.['required'] && (f['last_name'].dirty || f['last_name'].touched)">
                    Please fill last name.
                </div>
              </div>
              <div class="col-md-6 mt-2 px-4">
                <label for="validationDOB" class="form-label">Date of Birth</label>
                <div class="input-group mb-3">
                    <input type="text" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" formControlName="dob" class="form-control mb-0" placeholder="DOB"
                        aria-label="DOB">
                    <div class="input-group-append d-flex" [owlDateTimeTrigger]="dt2">
                        <span class="input-group-text rounded-0"><i class="fa fa-calendar"></i></span>
                    </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                <div class="invalid-feedback d-block"
                    *ngIf="f['dob'].errors?.['required'] && (f['dob'].dirty || f['dob'].touched)">
                    Please select dob.
                </div>
                <div class="invalid-feedback d-block"
                    *ngIf="f['dob'].errors?.['futureDate'] && (f['dob'].dirty || f['dob'].touched)">
                    Date of birth cannot be in the future.
                </div>
              </div>
              <div class="col-md-6 mt-2 px-4">
                <label for="validationCountry" class="form-label">Country</label>
                <select class="form-select" formControlName="country" id="validationCountry">
                  <option value="">Choose...</option>
                  <ng-container  *ngFor="let country of countries">
                      <option value="{{country.code}}">{{country.name}}</option>
                  </ng-container>
                </select>
                <div class="invalid-feedback d-block"
                    *ngIf="f['country'].errors?.['required'] && (f['country'].dirty || f['country'].touched)">
                    Please select country.
                </div>
              </div>
              <div class="col-md-6 mt-2 px-4" *ngIf="user && (user.role=='gymowner' || user.role=='choreographer')">
                <label for="validationDefaultGym" class="form-label">Gym / Team Name</label>
                <input type="text" class="form-control" formControlName="gym_name" id="validationDefaultGym" value="">
                <div class="invalid-feedback d-block"
                    *ngIf="f['gym_name'].errors?.['required'] && (f['gym_name'].dirty || f['gym_name'].touched)">
                    Please fill gym name.
                </div>
              </div>
              <!-- <div class="col-md-6" *ngIf="user && user.role=='gymowner'">
                <label for="validationDefaultCoach" class="form-label">Number of Coaches in Gym</label>
                <input type="text" class="form-control" formControlName="number_of_coaches" id="validationDefaultCoach" value="">
                <div class="invalid-feedback d-block"
                    *ngIf="(f['number_of_coaches'].errors?.['required'] || f['number_of_coaches'].errors?.['pattern']) && (f['number_of_coaches'].dirty || f['number_of_coaches'].touched)">
                    Please fill number of coaches in gym.
                </div>
              </div>
              <div class="col-md-6" *ngIf="user && user.role=='gymowner'">
                <label for="validationDefaultAthlete" class="form-label">Number of Athletes in Gym</label>
                <input type="text" class="form-control" id="validationDefaultAthlete" formControlName="number_of_athletes" value="">
                <div class="invalid-feedback d-block"
                    *ngIf="(f['number_of_coaches'].errors?.['required'] || f['number_of_coaches'].errors?.['pattern']) && (f['number_of_coaches'].dirty || f['number_of_coaches'].touched)">
                    Please fill number of coaches in gym.
                </div>
              </div> -->


              <span class="text-uppercase pt-3">Change Password</span>
              <div class="col-md-6 mt-2 px-4">
                <label for="validationCurrentPwd" class="form-label">Current Password</label>
                <input type="password" class="form-control" formControlName="oldpassword" id="validationCurrentPwd">
                <div class="invalid-feedback d-block"
                    *ngIf="(f['oldpassword'].errors?.['required'] || f['oldpassword'].errors?.['minlength']) && (f['oldpassword'].dirty || f['oldpassword'].touched)">
                    Please fill 8 character long password.
                </div>
              </div>
              <div class="col-md-6 mt-2 px-4">
                <label for="validationNewPwd" class="form-label">New Password</label>
                <input type="password" class="form-control" formControlName="password" id="validationNewPwd">
                <div class="invalid-feedback d-block"
                    *ngIf="(f['password'].errors?.['minlength'] || f['password'].errors?.['match']) && (f['password'].dirty || f['password'].touched)">
                    Please fill 8 character long password.
                </div>
              </div>

              <div class="col-12 text-end">
                <button class="btn btn-lg btn-gold" type="submit">Update <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></button>
              </div>
            </form>
          </div>

        </div>
        <div class="row pb-4 pb-md-0">
          <div class="col-12 bg-white-opac mb-5" *ngIf="user && user.plans && user.plans.length>0">
            <div class="">
                <div class="h6 text-uppercase py-3">Purchase History</div>
                <div class="table-responsive font-mulish">
                  <table class="table table-borderless">
                    <thead class="bg-gold text-white">
                      <tr>
                        <th scope="col">#</th>
                        <!-- <th scope="col">Start Date</th> -->
                        <th scope="col">End Date</th>
                        <th scope="col">Description</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Invoice</th>
                        <!-- <th scope="col">Invoice Pdf</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let p of user.plans">
                        <th scope="row">1</th>
                        <!-- <td>{{ p.dt | date :'medium'}}</td> -->
                        <td>{{ p.trial_ends | date: 'dd/MM/yyyy'}}
                        </td>
                        <td>{{p.description}}</td>
                        <td>{{p.amount}} USD</td>
                        <td *ngIf="p.subscription_premium_info && p.subscription_premium_info!=='null' && p.subscription_premium_info!=''"><a href="{{p.subscription_premium_info}}" target="_blank">Download</a></td>
                        <td *ngIf="!p.subscription_premium_info || p.subscription_premium_info==='null' || p.subscription_premium_info==''">N/A</td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div class="col-lg-4">
        <div class="row">

          <div class="col-12 mb-5">
            <div class="card text-center border-0 shadow">
              <div class="card-header mb-5 border-0 p-0">
                <div class="icon shadow upload-image-wrap"> <img *ngIf="!user || !user.profile_picture_full || user.profile_picture_full==''" src="assets/brand/profile.png" class="img-fluid user-img" /> 
                  <img *ngIf="user && user.profile_picture_full && user.profile_picture_full!=''" src="{{user.profile_picture_full}}" class="img-fluid user-img" /> 
                  <i class="upload-image fa fa-camera" (click)="fileUpload.click()"></i>
                </div>
                <!-- <div class="gym-title">Gym<br>Owner</div> -->
                <input type="file" class="file-upload" style="display:none"  #fileUpload accept="image/*"
                (change)="onFileSelected($event)" >
              </div>
              <div class="card-body font-mulish pt-4" *ngIf="user">
                <h5 class="card-title text-uppercase font-oswald">{{user?.first_name +' '+user?.last_name}}</h5>
                <h6 class="card-subtitle mb-2 text-muted" *ngIf="user && user.role=='gymowner'">{{user.role}}<span *ngIf="user.gym_name!=''">@{{user.gym_name}}</span></h6>
                <h6 class="card-subtitle mb-2 text-muted" *ngIf="user && user.role=='coach'">{{user.role}}<span *ngIf="user.first_name!=''">@{{user.first_name}}</span></h6>
                <!-- <div class="row align-items-center">
                  <div class="col-4">{{user?.connections?.athlete?.length ? user?.connections?.athlete?.length : '0'}}<p class="text-muted">Connected<br/> Athlete</p>
                  </div>
                  <div class="col-4">{{user?.athlete_invites_left?.length ? user?.athlete_invites_left?.length : '0'}}<p class="text-muted">Current<br/> Limit</p>
                  </div>
                  <div class="col-4"><a href="#" class="btn btn-sm bg-gold text-white">BUY MORE</a></div>
                </div> -->
                <ng-container *ngIf="user && user.role=='gymowner'">
                  <div class="row align-items-center">
                    <div class="col-6">{{user?.connections?.coach?.length ? user?.connections?.coach?.length : '0'}}<p class="text-muted">Connected<br/> Coaches</p>
                    </div>
                    <div class="col-6">{{user?.coach_invites_left ? user?.coach_invites_left : '0'}}<p class="text-muted">Current<br/> Limit</p>
                    </div>
                    <!-- <div class="col-4"><a href="#" class="btn btn-sm bg-gold text-white">BUY MORE</a></div> -->
                  </div>
                </ng-container>
                <div *ngIf="user && user.plan && user.plan.subscription_cancelled==0" class="mb-2 ft-wght-500">{{user.plan.description}}</div>
                <div *ngIf="user && user.plan && user.plan.subscription_cancelled==2" class="mb-2 ft-wght-500"><span class="text-red">Subscription Paused -</span> Level 1</div>
                <div *ngIf="user && (!user.plan || user.plan.subscription_cancelled==1)" class="mb-2 ft-wght-500"><span class="text-red">Upgrade Subscription Plans -</span> Level 1</div>
                
                <button class="btn btn-sm btn-gold mt-2" data-bs-toggle="modal" data-bs-target="#subscription-update-modal" href="javascript:void(0)">Manage my Subscription</button>

              </div>
            </div>
          </div>
          <div class="col-12">

            <div class="bg-white" *ngIf="card">
              <div class="paymentcard">
                <div class="paymentcard-inner">
                  <div class="front">
                    <img src="assets/extra/map.png" class="map-img">
                    <div class="row img-wrap">
                      <img src="assets/extra//chip.png" width="60px">
                    </div>
                    <div class="cardrow paymentcard-no">
                      <p>****</p>
                      <p>****</p>
                      <p>****</p>
                      <p>{{card.last4}}</p>
                    </div>
                    <div class="cardrow paymentcard-holder">
                      <p>Card Holder</p>
                      <p>VALID TILL</p>
                    </div>
                    <div class="cardrow name">
                      <p>------</p>
                      <p>{{card.exp_month}} / {{card.exp_year}}</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!-- <div class="payment-card"><img src="assets/brand/payment-card.png" class="img-fluid"></div> -->
            <div class="bg-white" *ngIf="user && user.plan && user.plantype!='' && user.plantype!='parent' && user.plan.type!='manual'">
              <form [formGroup]="cardForm" (ngSubmit)="onCardUpdate(cardForm)" class="row row-form g-3 p-3 font-mulish">
                <div class="">

                  <label for="cardholder" class="form-label">Name</label>

                  <input type="text" class="form-control" id="cardholder" formControlName="name" value="">
                  <div class="invalid-feedback d-block"
                    *ngIf="(f2['name'].errors?.['required'] && (f2['name'].dirty || f2['name'].touched))">
                    Please fill card holder name.
                  </div>
                </div>

                <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                  <ngx-stripe-card containerClass="cardcontainer" [options]="cardOptions"></ngx-stripe-card>
                </ngx-stripe-elements>

                <div class="col-12 text-center">

                  <button class="btn btn-lg btn-gold" type="submit">Update <i *ngIf="formSubmitting2"
                      class="fa fa-spinner fa-spin"></i></button>

                </div>

              </form>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>

</section>
